import { Component, Inject, Input } from '@angular/core';

@Component({
    selector: 'drop-menu-item',
    template: require('./drop-menu-item.component.html')
})
export class DropMenuItemComponent {
    @Input() public item: any;
    @Input() public expand: any;

    constructor(@Inject('$state') private $state: any) {
    }

    public navigate(event: any) {
        event.preventDefault();
        this.$state.go(this.item.sref, this.item.params);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/side-menu/drop-menu-item/drop-menu-item.component.ts